export default "__VITE_ASSET__3f471c3f__$_?inline__"